import { useMutation } from '@tanstack/react-query';

import { PricingPlanObjectFormSchemaValues } from 'src/features/pricing/sites/utils/formSchema';
import { SitePricingPlan } from 'src/features/pricing/sites/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { STORAGE_PREFIX } from 'src/config';

const RESOURCE = `${STORAGE_PREFIX}/:parkingId/sites/site-pricing-plan/:planId/`;
type MutationFnType = typeof mutationFn;

interface DTO {
    data: PricingPlanObjectFormSchemaValues;
    planId: string;
    parkingId: string;
}
const mutationFn = ({ planId,parkingId, data }: DTO): Promise<SitePricingPlan> => {
    return axios.put(formatResourcePath(RESOURCE, { planId, parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateSitePricingPlan };
